"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crumb = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var theme_1 = require("../theme");
var Icon = function (_a) {
    var icon = _a.icon;
    return React.cloneElement(icon, { size: theme_1.theme.space.space24 });
};
var A = styled_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  text-decoration: none;\n  display: inline-flex;\n\n  :hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  > * {\n    margin-right: ", ";\n  }\n\n  :hover {\n    svg {\n      color: ", ";\n    }\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  text-decoration: none;\n  display: inline-flex;\n\n  :hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  > * {\n    margin-right: ", ";\n  }\n\n  :hover {\n    svg {\n      color: ", ";\n    }\n  }\n"])), function (props) { return (props.active ? theme_1.theme.colors.n900 : theme_1.theme.colors.n400); }, function (props) {
    return props.active ? theme_1.theme.fontWeights.medium : theme_1.theme.fontWeights.regular;
}, theme_1.theme.colors.n900, theme_1.theme.space.space8, theme_1.theme.colors.n500);
var Span = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  display: inline-flex;\n\n  > * {\n    margin-right: ", ";\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  display: inline-flex;\n\n  > * {\n    margin-right: ", ";\n  }\n"])), function (props) { return (props.active ? theme_1.theme.colors.n900 : theme_1.theme.colors.n400); }, function (props) {
    return props.active ? theme_1.theme.fontWeights.medium : theme_1.theme.fontWeights.regular;
}, theme_1.theme.space.space8);
var LabelWrapper = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", ";\n  cursor: default;\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  cursor: default;\n  line-height: ", ";\n"])), theme_1.theme.fontSizes.fontsize14, theme_1.theme.space.space40);
var ItemWrapper = styled_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n"])));
/**
 * A single breadcrumb within a breadcrumb trail.
 */
exports.Crumb = React.forwardRef(function (_a, ref) {
    var icon = _a.icon, text = _a.text, active = _a.active, href = _a.href, onClick = _a.onClick, className = _a.className, label = _a.label;
    var contents = (React.createElement(React.Fragment, null,
        icon && React.createElement(Icon, { icon: icon }),
        text));
    var styledContent = href ? (React.createElement(A
    // styled.a() doesn't like gettin a ref that's not explicitly and solely
    // for HTMLAnchorElements for some reason.
    , { 
        // styled.a() doesn't like gettin a ref that's not explicitly and solely
        // for HTMLAnchorElements for some reason.
        ref: ref, href: href, active: active, onClick: onClick, className: className }, contents)) : (React.createElement(Span, { ref: ref, active: active, onClick: onClick, className: className }, contents));
    return (React.createElement(ItemWrapper, null,
        React.createElement(LabelWrapper, null, label),
        styledContent));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Crumb.js.map